/**
 * title.strategy.ts
 * -----------------
 * Custom Angular TitleStrategy.
 *
 * Formats the browser tab title as:
 *   <Page Name> | Automated Guardrail Assessment Tool
 *
 * If a route has no `title` defined it falls back to just the app name.
 */

import { Injectable }     from '@angular/core';
import { Title }          from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_NAME = 'Automated Guardrail Assessment Tool';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(
      pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME
    );
  }
}
